import React, { useState } from 'react';

import { Project, Tag } from '../../types/common';
import PillButton from '../button/PillButton';
import ProjectCard from '../card/ProjectCard';

type ProjectsType = {
  projects: Project[];
  tags: Tag[];
};

const Projects = ({ projects, tags }: ProjectsType) => {
  const [filterTags, setFilterTags] = useState<string[]>([]);

  const handleFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (filterTags.includes(event.currentTarget.innerText)) {
      const newFilterTags = filterTags.filter(
        (tag) => tag !== event.currentTarget.innerText
      );

      setFilterTags(newFilterTags);
      return;
    }
    const newFilterTags = [...filterTags, event.currentTarget.innerText];
    setFilterTags(newFilterTags);
  };

  const modifiedProjects = projects.map((project) => {
    const projectTags = tags.filter((tag) => project.tags.includes(tag.tagId));
    const newProject = {
      ...project,
      tags: projectTags.map((tag) => tag.tag),
    };
    return newProject;
  });

  const filteredProjects = () => {
    if (filterTags.length === 0) {
      return modifiedProjects;
    }
    const newProjects = modifiedProjects.filter((project) => {
      const isInFilter = project.tags.some((tag) => filterTags.includes(tag));
      if (!isInFilter) return;
      // eslint-disable-next-line consistent-return
      return project;
    });

    return newProjects;
  };

  return (
    <div className="flex flex-col gap-7 py-8">
      <div className="text-center text-5xl text-mainWhite md:text-left">
        <h1 id="portfolio">Portfolio</h1>
      </div>
      <div className="flex flex-col gap-5 justify-center items-center flex-wrap md:flex-row md:justify-start">
        <small className="text-xl text-accentGray">Fillter by:</small>
        <div className="flex flex-wrap justify-start gap-2 md:gap-3">
          {tags.map((tag) => (
            <PillButton
              tagColor={filterTags.includes(tag.tag) ? tag.color : 'white'}
              tagName={tag.tag}
              key={tag.id}
              handleFilter={handleFilter}
            />
          ))}
        </div>
      </div>
      <div className=" grid grid-cols-1 justify-items-center gap-3 md:grid-cols-2 md:gap-6 lg:grid-cols-3 lg:justify-items-stretch">
        {filteredProjects().map((project) => (
          <ProjectCard project={project} tags={tags} key={project.id} />
        ))}
      </div>
    </div>
  );
};

export default Projects;
